import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
  Card,
  CardContent,
  Grid,
  Paper,
} from '@material-ui/core';
import {
  renderTextField,
  renderSelectField6,
} from '../../form-global-components/components-form-components-for-react-final-form';
import {
  CROSSPOINT_BEHAVIORAL_HEALTH_SERVICES,
  NA_YES_NO,
  RECEIVING_BEHAVIORAL_HEALTH_SERVICES,
                                                  // NO_YES,
                                                  // UNKNOWN_YES_NO,
} from '../../../actions/action-constants';
class FormFieldsClientsTabsTabResidentialCMPrograms extends Component {
  render() {
    return (
      <div>
        <Paper >
          <Card>
            <CardContent>

                <Grid container spacing={3}>  
                  <Grid item xs={12} >
                    <Field
                      autoFocus
                      component={renderSelectField6}
                      locked={this.props.locked}
                      dataArray={NA_YES_NO}
                      id='clientlifeskills' 
                      name='clientlifeskills'
                      label='Client Life Skills'
                      footerMessage=''
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={3}>  
                  <Grid item xs={12} >
                    <Field
                      autoFocus
                      component={renderSelectField6}
                      locked={this.props.locked}
                      dataArray={NA_YES_NO}
                      id='clientjobteadinesstraining' 
                      name='clientjobteadinesstraining'
                      label='Client Job Readiness Training'
                      footerMessage=''
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={3}>  
                  <Grid item xs={12} >
                    <Field
                      autoFocus
                      component={renderSelectField6}
                      locked={this.props.locked}
                      dataArray={NA_YES_NO}
                      id='clientcbtprogramming' 
                      name='clientcbtprogramming'
                      label='Client CBT Programming'
                      footerMessage=''
                    />
                  </Grid>
                </Grid>
                            
                <Grid container spacing={3}>
                  <Grid item xs={12} >
                      <Field
                        locked={this.props.locked}
                        component={renderTextField}
                        id='clientcbtprogramminghourscomplete'
                        name='clientcbtprogramminghourscomplete'
                        label='Client CBT Programming Hours Complete'
                      />
                  </Grid>
                </Grid>

                <Grid container spacing={3}>  
                  <Grid item xs={12} >
                    <Field
                      autoFocus
                      component={renderSelectField6}
                      locked={this.props.locked}
                      dataArray={NA_YES_NO}
                      id='clientparenting' 
                      name='clientparenting'
                      label='Client Parenting'
                      footerMessage=''
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={3}>  
                  <Grid item xs={12} >
                    <Field
                      autoFocus
                      component={renderSelectField6}
                      locked={this.props.locked}
                      dataArray={NA_YES_NO}
                      id='clientwellness' 
                      name='clientwellness'
                      label='Client Wellness'
                      footerMessage=''
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={3}>  
                  <Grid item xs={12} >
                    <Field
                      autoFocus
                      component={renderSelectField6}
                      locked={this.props.locked}
                      dataArray={NA_YES_NO}
                      id='clientfinancialliteracy' 
                      name='clientfinancialliteracy'
                      label='Client Financial Literacy'
                      footerMessage=''
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={3}>  
                  <Grid item xs={12} >
                    <Field
                      autoFocus
                      component={renderSelectField6}
                      locked={this.props.locked}
                      dataArray={RECEIVING_BEHAVIORAL_HEALTH_SERVICES}
                      id='receivingbehavioralhealthservices' 
                      name='receivingbehavioralhealthservices'
                      label='Receiving Behavioral Health Services'
                      footerMessage=''
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={3}>  
                  <Grid item xs={12} >
                    <Field
                      autoFocus
                      component={renderSelectField6}
                      locked={this.props.locked}
                      dataArray={CROSSPOINT_BEHAVIORAL_HEALTH_SERVICES}
                      id='crosspointbehavioralhealthservices' 
                      name='crosspointbehavioralhealthservices'
                      label='Crosspoint Behavioral Health Services'
                      footerMessage=''
                    />
                  </Grid>
                </Grid>

            </CardContent>
          </Card>
        </Paper>  

      </div>
    );
  }
}
FormFieldsClientsTabsTabResidentialCMPrograms.propTypes = {
  locked: PropTypes.bool,
}
export default FormFieldsClientsTabsTabResidentialCMPrograms;